<template>
    <div>
        <div style="margin: 1px 40px 40px;"></div>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="邮箱" required prop="email">
                            <el-input ref="ipt01" v-model="form.email" placeholder="请输入邮箱" maxlength="100"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                 </el-form-item>
                <el-row><el-col></el-col></el-row>
                <el-row><el-col></el-col></el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
    import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity", "mode"],
        data() {
             var checkEmail = (rule, value, callback) => {
                const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+$/;
                if (value != null && value != "" && !reg.test(value)) {
                    callback(new Error("电子邮箱格式错误"));
                } else {
                    callback();
                }
            };
            var checkMob = (rule, value, callback) => {
                const reg = /^1[3456789]\d{9}$/;
                const reg1 = /^0\d{2,3}-?\d{7,8}$/;
                if (value != null && value != "" && !reg.test(value) && !reg1.test(value)) {
                    callback(new Error("联系电话格式错误"));
                } else {
                    callback();
                }
            };
            let form = {
                einvoiceId: this.entity.einvoiceId,
                email: this.entity.email
            }
            let data = {
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                einvtypeCodeOptions: [],
                form,
                formRules: {
                    email : [
                        { required: true, message: "请输入邮箱", trigger: "blur" },
                        { validator: checkEmail, trigger: "blur" }
                    ]
                }
            }
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits()
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: "SENDMAINEMAIL"
            })
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
